import React from 'react';
import { Route } from 'react-router-dom';
import ImportFile from './containers/ImportFile';
import { WithPermissions } from 'react-admin';

const ImportFileWithPermissions = ({ location, match }) => (
  <WithPermissions
    authParams={{ key: match.path, params: location.params }}
    // location is not required but it will trigger a new permissions check if specified when it changes
    location={location}
    render={({ permissions }) => <ImportFile permissions={permissions} />}
  />
);

export default [<Route exact path="/importfiles" component={ImportFileWithPermissions} />];



// WEBPACK FOOTER //
// ./src/customRoutes.js